// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields, company} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (company) {
		for (let i = 0; i < fields.numberOfSignatories; i++) {
			if (fields['customer_signatory_firstname_' + i].length <= 0 ||
				fields['customer_signatory_lastname_' + i].length <= 0) {
				return false;
			}

			if (!Validator.validateEmail(fields['customer_signatory_email_' + i])) {
				return false;
			}
		}

        if (company && !fields.ubo_fields_valid) {
            return false;
        }
	}

	/**
	 * Grunduppgifter radio needs to be selected
	 */
	if (!optionsListValueSelected(fields.kyc_documentation)) {
		return false;
	}

	if (fields.kyc_documentation.options[0].checked && fields.kyc_date.length <= 0) {
		return false;
	}

	/**
	 * Grunduppgifter fields all need to be entered
	 */
	if (fields.kyc_documentation.options[1].checked) {
		if (fields.customer_address_street.length <= 0) {
			return false;
		}

		if (fields.customer_address_zipcode.length <= 0) {
			return false;
		}

		if (fields.customer_address_city.length <= 0) {
			return false;
		}

		if (fields.customer_phonenumber_home.length <= 0) {
			return false;
		}

		if (company) {
			if (fields.contact_firstname.length <= 0) {
				return false;
			}

			if (fields.contact_lastname.length <= 0) {
				return false;
			}

			if (fields.contact_email.length <= 0 || !Validator.validateEmail(fields.contact_email)) {
				return false;
			}
		}

		if (!fields.checkbox_idcheck_id.checked &&
			!fields.checkbox_idcheck_drivinglic.checked &&
			!fields.checkbox_idcheck_passport.checked &&
			!fields.checkbox_idcheck_known.checked &&
			!fields.checkbox_idcheck_bankid.checked) {
			return false;
		}

		if (company) {
			if (!fields.ubo_checkbox_idcheck_id.checked &&
				!fields.ubo_checkbox_idcheck_drivinglic.checked &&
				!fields.ubo_checkbox_idcheck_passport.checked &&
				!fields.ubo_checkbox_idcheck_bankid.checked) {
				return false;
			}
		}

		if (!optionsListValueSelected(fields.checkbox_customer_kyc_non_proff)) {
			return false;
		}

		if (!optionsListValueSelected(fields.radio_distans)) {
			return false;
		}

		if (fields.radio_distans.options[1].checked &&
			(!fields.checkbox_customer_extcheck.checked ||
				!fields.checkbox_customer_countercheck.checked)) {
			return false;
		}
	}

	if (company) {
		return !!(
			fields.customer_firstname.length > 0
			&& Validator.validateOrgNum(fields.customer_social_security_number, true)
			&& Validator.validateEmail(fields.customer_email)
		);
	}

	return !!(
		fields.customer_firstname.length > 0 &&
		fields.customer_lastname.length > 0 &&
		Validator.validateSsn(fields.customer_social_security_number, false) &&
		Validator.validateEmail(fields.customer_email)
	);
}

function optionsListValueSelected(optionsList) {
	const options = optionsList.options;
	for (let i = 0; i < options.length; i++) {
		if (options[i].checked) {
			return true;
		}
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/fair-futur/CustomerInformation.fulfillment.js